export const SessionStorageKeys = {
    authUsername: 'w-auth-username',
    onboardingUsername: 'w-onboarding-username',
    deviceComplianceInfoResult: 'deviceComplianceInfoResult',
    deviceComplianceChecksInfo: 'deviceComplianceChecksInfo',
    sessionLifespanLimit: 'w-session-lifespan-limit',
    sessionTimeoutLimit: 'w-session-timeout-limit',
    onboardingV3Enabled: 'w-auth-onboarding-v3-enabled',
    onboardingStatus: 'w-auth-onboarding-status',
    userSettings: 'w-auth-user-settings',
    companySettings: 'w-auth-settings',
    featureSettings: 'w-auth-features',
    helpInfo: 'w-auth-help-info',
    passwordIsActivationCode: 'w-auth-password-is-activation-code',
    redirectionCompleted: 'w-auth-redirection-completed',
    mfaType: 'mfaType',
    mfaTimeout: 'mfaTimeout',
    guestAccess: 'w-auth-is-guest-access',
    resetPasswordPhoneInfo: 'w-auth-reset-pw-phone-info'
};


// WEBPACK FOOTER //
// ./src/scripts/services/sessionStorageKeys.const.js